import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { InactivityService } from './auth/inactivity.service';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'complydome';

  loadSpinner = true;

  constructor(private authService: AuthService, private router: Router) {}

  // constructor(private router: Router, private inactivityService: InactivityService) {
  //   // Only subscribe to NavigationEnd events
  //   this.router.events.pipe(
  //     filter((event): event is NavigationEnd => event instanceof NavigationEnd)
  //   ).subscribe((event: NavigationEnd) => {
  //     // Now TypeScript knows event is definitely NavigationEnd
  //     if (event.urlAfterRedirects === "/") {
  //       this.inactivityService.stopWatching();
  //       console.log('Stopped watching due to navigation to login');
  //     }
  //   });
  // }

  ngOnInit() {
    this.authService.checkSession().subscribe(isAuthenticated => {
      this.loadSpinner = false;
      if (isAuthenticated) {
        if (location.pathname === '/') {
          this.router.navigate(['/shell/dashboard']);
        }
      } else {
        if (this.isPublicRoute(location.pathname)) {
          return;
        }

        this.router.navigate(['/login']);
      }
    });
  }

  isPublicRoute(path: string): boolean {
    const publicRoutes = ['/login', '/forgot-password', '/password-reset-sent', '/pwd-recovery', '/mfa', '/guest/onboarding', '/guest/policy-acknowledgment', '/guest/review'];
    return publicRoutes.includes(path) || path.startsWith('/guest/campaign');
  }
}
